module.exports = __webpack_public_path__ + "img/zhxy-3.58d0e20e.png";